"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Grid config
 * consumed by Grid Provider
 */
var gridConfig = {
  breakpoints: {
    md: _breakpoints["default"].md,
    lg: _breakpoints["default"].lg,
    xl: _breakpoints["default"].xl
  },
  container: {
    padding: 0
  },
  row: {
    padding: 14
  },
  col: {
    padding: 14
  },
  springWidth: 1440
};
var _default = gridConfig;
exports["default"] = _default;
//# sourceMappingURL=gridConfig.js.map